import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import MultilingualField from '../components/MultilingualField';
import { IconEdit, IconTrash } from '../components/Icons';
import '../components/AdminUI.css';

const STATUS_COLORS = { pending: 'amber', confirmed: 'green', cancelled: 'red', completed: 'gray', no_show: 'red' };
const DAYS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

export default function Appointments() {
  const [tab, setTab] = useState('bookings');
  return (
    <div className="admin-page">
      <div className="admin-tabs">
        <button className={`admin-tab ${tab === 'bookings' ? 'active' : ''}`} onClick={() => setTab('bookings')}>Réservations</button>
        <button className={`admin-tab ${tab === 'services' ? 'active' : ''}`} onClick={() => setTab('services')}>Services & tarifs</button>
        <button className={`admin-tab ${tab === 'hours' ? 'active' : ''}`} onClick={() => setTab('hours')}>Horaires</button>
        <button className={`admin-tab ${tab === 'holidays' ? 'active' : ''}`} onClick={() => setTab('holidays')}>Jours fermés</button>
      </div>

      {tab === 'bookings' && <Bookings />}
      {tab === 'services' && <Services />}
      {tab === 'hours' && <OpeningHours />}
      {tab === 'holidays' && <Holidays />}
    </div>
  );
}

function Bookings() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState('');
  const load = () => axios.get('/appointments', { params: { status } }).then((r) => setItems(r.data.data || []));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);
  const update = async (a, s) => { await axios.patch(`/appointments/${a.id}/status`, { status: s }); load(); };
  const remove = async (id) => { if (window.confirm('Supprimer ?')) { await axios.delete(`/appointments/${id}`); load(); } };

  return (
    <>
    <div className="admin-toolbar">
      <select className="admin-select" value={status} onChange={(e) => setStatus(e.target.value)} style={{ maxWidth: 220 }}>
        <option value="">Tous les statuts</option>
        <option value="pending">En attente</option>
        <option value="confirmed">Confirmé</option>
        <option value="cancelled">Annulé</option>
        <option value="completed">Terminé</option>
        <option value="no_show">Absent</option>
      </select>
    </div>
    <div className="admin-card" style={{ padding: 0, overflow: 'auto' }}>
      <table className="admin-table">
        <thead><tr><th>Code</th><th>Date</th><th>Client</th><th>Téléphone</th><th>Service</th><th>Statut</th><th></th></tr></thead>
        <tbody>
          {items.map((a) => (
            <tr key={a.id}>
              <td><code>{a.short_code || a.booking_code?.slice(0, 8)}</code></td>
              <td>{new Date(a.scheduled_at).toLocaleString('fr-FR')}</td>
              <td>{a.customer_name}<br /><small style={{ color: '#6b7280' }}>{a.customer_email}</small></td>
              <td>{a.customer_phone}</td>
              <td>{a.service?.name}</td>
              <td><span className={`admin-pill ${STATUS_COLORS[a.status]}`}>{a.status}</span></td>
              <td>
                <div className="admin-actions">
                  <select className="admin-select" value={a.status} onChange={(e) => update(a, e.target.value)} style={{ width: 130 }}>
                    <option value="pending">en attente</option>
                    <option value="confirmed">confirmé</option>
                    <option value="cancelled">annulé</option>
                    <option value="completed">terminé</option>
                    <option value="no_show">absent</option>
                  </select>
                  <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(a.id)}>
                    <IconTrash />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </>
  );
}

function Services() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => axios.get('/appointment-services').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (editing.id) await axios.put(`/appointment-services/${editing.id}`, editing);
    else await axios.post('/appointment-services', editing);
    setEditing(null);
    load();
  };
  const remove = async (id) => { if (window.confirm('Supprimer ?')) { await axios.delete(`/appointment-services/${id}`); load(); } };

  return (
    <>
      {!editing && (
        <div className="admin-toolbar" style={{ justifyContent: 'flex-end' }}>
          <button className="admin-btn admin-btn-gold" onClick={() => setEditing({ slug: '', name: '', i18n: {}, duration_minutes: 30, price: 0, slot_capacity: 1, icon: '', is_active: true, sort_order: 0 })}>
            + Nouveau service
          </button>
        </div>
      )}
      {editing && (
        <div className="admin-form-card">
          <div className="admin-form-header">
            <h3>{editing.id ? 'Modifier le service' : 'Nouveau service'}</h3>
          </div>
          <div className="admin-form-body">
            <div className="admin-form-section">
              <div className="admin-form-section-title">Service</div>
              <div className="admin-grid admin-grid-2">
                <div><label className="admin-label">Slug</label><input className="admin-input" value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} /></div>
                <div><label className="admin-label">Nom (FR par défaut)</label><input className="admin-input" value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} /></div>
                <div><label className="admin-label">Durée (min)</label><input className="admin-input" type="number" value={editing.duration_minutes} onChange={(e) => setEditing({ ...editing, duration_minutes: parseInt(e.target.value || 30) })} /></div>
                <div><label className="admin-label">Prix (MAD)</label><input className="admin-input" type="number" value={editing.price} onChange={(e) => setEditing({ ...editing, price: parseFloat(e.target.value || 0) })} /></div>
                <div><label className="admin-label">Capacité par créneau</label><input className="admin-input" type="number" min="1" value={editing.slot_capacity} onChange={(e) => setEditing({ ...editing, slot_capacity: parseInt(e.target.value || 1) })} /></div>
                <div><label className="admin-label">Icône (clé)</label><input className="admin-input" value={editing.icon || ''} onChange={(e) => setEditing({ ...editing, icon: e.target.value })} /></div>
              </div>
            </div>
            <MultilingualField label="Traductions" value={editing.i18n} fields={['name', 'description']} multiline={['description']} onChange={(v) => setEditing({ ...editing, i18n: v })} />
          </div>
          <div className="admin-form-actions">
            <button className="admin-btn admin-btn-outline" onClick={() => setEditing(null)}>Annuler</button>
            <button className="admin-btn admin-btn-gold" onClick={save}>Enregistrer</button>
          </div>
        </div>
      )}
      <div className="admin-card" style={{ padding: 0, overflow: 'auto' }}>
        <table className="admin-table">
          <thead><tr><th>Slug</th><th>Nom</th><th>Durée</th><th>Prix</th><th>Capacité</th><th>Actif</th><th></th></tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id}>
                <td>{s.slug}</td><td>{s.name}</td><td>{s.duration_minutes} min</td>
                <td>{s.price} MAD</td><td>{s.slot_capacity}</td>
                <td><span className={`status-badge ${s.is_active ? 'active' : 'inactive'}`}>{s.is_active ? 'Actif' : 'Inactif'}</span></td>
                <td>
                  <div className="admin-actions">
                    <button className="admin-icon-btn" title="Modifier" aria-label="Modifier" onClick={() => setEditing(s)}>
                      <IconEdit />
                    </button>
                    <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(s.id)}>
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

function OpeningHours() {
  const [hours, setHours] = useState([]);
  const load = () => axios.get('/opening-hours').then((r) => setHours(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => { await axios.put('/opening-hours', { hours }); load(); };

  return (
    <div className="admin-card">
      {hours.map((h, i) => (
        <div key={h.day_of_week} className="admin-grid admin-grid-2" style={{ alignItems: 'center', marginBottom: 8 }}>
          <div style={{ fontWeight: 600 }}>{DAYS[h.day_of_week]}</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <label><input type="checkbox" checked={!!h.is_closed} onChange={(e) => setHours(hours.map((x, j) => j === i ? { ...x, is_closed: e.target.checked } : x))} /> Fermé</label>
            <input className="admin-input" type="time" disabled={!!h.is_closed} value={h.open_time?.slice(0, 5) || ''} onChange={(e) => setHours(hours.map((x, j) => j === i ? { ...x, open_time: e.target.value } : x))} />
            <span>—</span>
            <input className="admin-input" type="time" disabled={!!h.is_closed} value={h.close_time?.slice(0, 5) || ''} onChange={(e) => setHours(hours.map((x, j) => j === i ? { ...x, close_time: e.target.value } : x))} />
          </div>
        </div>
      ))}
      <button className="admin-btn admin-btn-gold" onClick={save} style={{ marginTop: 12 }}>Enregistrer</button>
    </div>
  );
}

function Holidays() {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({ date: '', reason: '' });
  const load = () => axios.get('/holidays').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const create = async () => { await axios.post('/holidays', draft); setDraft({ date: '', reason: '' }); load(); };
  const remove = async (id) => { await axios.delete(`/holidays/${id}`); load(); };

  return (
    <div className="admin-card">
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input className="admin-input" type="date" value={draft.date} onChange={(e) => setDraft({ ...draft, date: e.target.value })} />
        <input className="admin-input" placeholder="Raison" value={draft.reason} onChange={(e) => setDraft({ ...draft, reason: e.target.value })} />
        <button className="admin-btn admin-btn-gold" onClick={create}>Ajouter</button>
      </div>
      <table className="admin-table">
        <thead><tr><th>Date</th><th>Raison</th><th></th></tr></thead>
        <tbody>
          {items.map((h) => (
            <tr key={h.id}>
              <td>{h.date}</td><td>{h.reason}</td>
              <td>
                <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(h.id)}>
                  <IconTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
